import {useEffect, useRef, useState} from "react";
import {
    calculateAsOfDate,
    calculateCurrentWithExemptionEstimateValue,
    calculateCurrentWoExemptAmountValue,
    countDecimals,
    getShortenedTaxDataSource,
    getUserFriendlyTaxDataSource,
    jurisdictionHead,
    jurisdictionYearFields
} from "../../../../helpers/utils/OrderDetailUtils";
import {hasPermission} from "../../../../helpers/utils/AccessControlUtils";
import NumberFormat from "react-number-format";
import moment from "moment";
import JurisdictionPickerModal from "../Common/Modals/JurisdictionPickerModal";
import {showToast} from "../../../../helpers/utils/Utils";
import {
    useLazyGetJurisdictionByTaxListQuery,

    useLazyGetJurisdictionsNextMonthDuesQuery
} from "../../../data/jurisdiction/jurisdictionApi";
import JurisdictionListModal from "../Modals/JurisdictionListModal";
// @ts-ignore
import {JurisdictionRowFormatting} from "../UtilComponents/JurisdictionRowFormatting";

interface JurisdictionSectionProps {
    curAccount: any;
    setShowAccount: any
    accounts: any[];
    setAccounts: any;
    setIsSavedResult: (isSaved: boolean) => void;
    autoCalculate: boolean;
    setAutoCalculate: any;
    certificate: any;
    setCertificate: (certificate: any) => void;
    showAccount: number;
    jurisdictionIdIndex: number;
    setJurisdictionIdIndex: (id: number) => void;
    removeJurisdiction: boolean;
    setRemoveJurisdiction: (remove: boolean) => void;
    setIsAddNewSummaryRow: (add: boolean) => void;
    setTaxYear: (year: string) => void;
    clearJurisRow: boolean;
    setClearJurisRow: (clear: boolean) => void;
    setUpdateTotalTaxValue: (update: boolean) => void;
    editable: boolean;
    county: string;
    orderId: any;
    setRender: any;
    primaryCollector: any;
    setUpdatedAccountIndexList?: any;
}

export function JurisdictionSection({
                                        curAccount,
                                        setShowAccount,
                                        accounts,
                                        setAccounts,
                                        setIsSavedResult,
                                        autoCalculate,
                                        setAutoCalculate,
                                        certificate,
                                        setCertificate,
                                        showAccount,
                                        jurisdictionIdIndex,
                                        setJurisdictionIdIndex,
                                        removeJurisdiction,
                                        setRemoveJurisdiction,
                                        setIsAddNewSummaryRow,
                                        setTaxYear,
                                        clearJurisRow,
                                        setClearJurisRow,
                                        setUpdateTotalTaxValue,
                                        editable,
                                        county,
                                        orderId,
                                        setRender,
                                        primaryCollector,
                                        setUpdatedAccountIndexList
                                    }: JurisdictionSectionProps) {

    const [isTaxSummaryReset, setIsTaxSummaryReset] = useState(false);
    const [showJurisdictionModal, setShowJurisdictionModal] = useState(false);
    const [reloadJurisdictionSection, setShowReloadJurisdictionSection] = useState(false);
    const [showJurisdictionPickerModal, setShowJurisdictionPickerModal] = useState(false);
    const [reloadJurisdictionList, setReloadJurisdictionList] = useState(false);
    const [reloadJurisdictionNextMonthDue, setReloadJurisdictionNextMonthDue] = useState(false);
    const [type, setType] = useState("");
    const [taxRateList, taxRateListApi] = useLazyGetJurisdictionByTaxListQuery();
    const [jurisdictionsNextMonthApi, jurisdictionsNextMonthApiResponse] = useLazyGetJurisdictionsNextMonthDuesQuery();
    const latestCertificateRef = useRef(certificate);

    useEffect(() => {
        latestCertificateRef.current = certificate;
    }, [certificate]);

    useEffect(() => {
        if (!taxRateListApi?.data || !certificate.accounts[showAccount]?.jurisdictionList) return;

        const updatedCertificate = {...certificate};
        const updatedJurisdictions = updatedCertificate.accounts[showAccount].jurisdictionList.map((jurisdiction: any) => {
            const match = taxRateListApi.data?.taxRateList.find(
                (p: any) => p.jurisdictionId === jurisdiction.jurisdictionId && p.year === parseInt(jurisdiction.bill_year, 10)
            );

            return match ? {...jurisdiction, tax_rate: match.rate} : jurisdiction;
        });

        updatedCertificate.accounts = [...updatedCertificate.accounts];
        updatedCertificate.accounts[showAccount] = {
            ...updatedCertificate.accounts[showAccount],
            jurisdictionList: updatedJurisdictions,
        };

        setCertificate(updatedCertificate);
        setIsSavedResult(false);
        setUpdateTotalTaxValue(true);
    }, [taxRateListApi]);


    useEffect(() => {
        if (!jurisdictionsNextMonthApiResponse?.data || !certificate.accounts[showAccount]?.jurisdictionList) return;

        const updatedCertificate = {...certificate};
        const updatedJurisdictionList = updatedCertificate.accounts[showAccount].jurisdictionList.map((jurisdiction: any) => {
            const match = jurisdictionsNextMonthApiResponse?.data?.jurisdictions.find(
                (p: any) =>
                    p.jurisdictionId === jurisdiction.jurisdictionId &&
                    parseInt(p.taxYear, 10) === parseInt(jurisdiction.bill_year, 10) &&
                    parseInt(p.baseTaxDue, 10) === parseInt(jurisdiction.baseDue, 10)
            );

            return match ? {...jurisdiction, nextMonthTaxDue: match.nextMonthTaxDue} : jurisdiction;
        });

        updatedCertificate.accounts = [...updatedCertificate.accounts];
        updatedCertificate.accounts[showAccount] = {
            ...updatedCertificate.accounts[showAccount],
            jurisdictionList: updatedJurisdictionList,
        };

        setCertificate(updatedCertificate);
        setReloadJurisdictionNextMonthDue(false);
        setIsSavedResult(false);
        setUpdateTotalTaxValue(true);
    }, [jurisdictionsNextMonthApiResponse]);


    useEffect(() => {
        if (removeJurisdiction || autoCalculate || clearJurisRow || reloadJurisdictionSection) {
            setUpdatedAccountIndexList((prev: any) => {
                return prev.includes(showAccount) ? prev : [...prev, showAccount];
            });
            setIsSavedResult(false);
            setShowReloadJurisdictionSection(false);
        }
        if (autoCalculate) {
                const latestCert = structuredClone(latestCertificateRef.current);
                const assessments = latestCert.accounts?.[showAccount]?.assessments ?? [];
                for (const index of [0, 1]) {
                    const assessment = assessments[index];
                    if (!assessment) continue;

                    calculateCurrentWoExemptAmountValue(
                        latestCert,
                        showAccount,
                        assessment,
                        setRender,
                        setCertificate
                    );

                   calculateCurrentWithExemptionEstimateValue(
                        latestCert,
                        showAccount,
                        assessment,
                        setRender,
                       setCertificate
                    );
                setAutoCalculate(false);
            }

        }
    }, [removeJurisdiction, clearJurisRow, autoCalculate, reloadJurisdictionSection]);

    useEffect(() => {
        const fetchTaxRates = async () => {
            if (!reloadJurisdictionList || !curAccount?.jurisdictionList) return;

            const ids: string[] = curAccount.jurisdictionList
                .filter((el: any) => el.jurisdictionId)
                .map((el: any) => el.jurisdictionId);

            setShowReloadJurisdictionSection(true);

            try {
                await taxRateList(ids);
            } catch (error) {
                console.error("Failed to fetch tax rates", error);
            } finally {
                setReloadJurisdictionList(false);
            }
        };

        fetchTaxRates();
    }, [reloadJurisdictionList, curAccount]);


    useEffect(() => {
        if (reloadJurisdictionNextMonthDue) {
            let list: any[] = [];
            curAccount?.jurisdictionList.forEach((el: any) => {
                if (el.jurisdictionId && el.baseDue !== "" && el.baseDue !== null && (el.nextMonthTaxDue === "" || el.nextMonthTaxDue === null)) {
                    let obj = {
                        "baseTaxDue": el.baseDue,
                        "nextMonthTaxDue": el.nextMonthTaxDue,
                        "jurisdictionId": el.jurisdictionId,
                        "taxYear": el.bill_year,
                        "asOfDate": el.asOfDate,
                    }
                    list.push(obj);
                }
            });


            const hasSuite = certificate.suites?.length > 0;

            const formattedList = list.map((item) => ({
                ...item,
                asOfDate: item.asOfDate instanceof Date ? item.asOfDate.toISOString() : item.asOfDate,
            }));

            if (list.length > 0) {
                jurisdictionsNextMonthApi({
                    hasSuite: hasSuite,
                    jurisdictions: formattedList
                });
            } else {
                setReloadJurisdictionNextMonthDue(false);
                showToast("No data found to update!");
            }
        }
    }, [reloadJurisdictionNextMonthDue]);

    useEffect(() => {
        if (isTaxSummaryReset) {
            setCertificate((prev : any) => {
                const updatedAccounts = [...prev.accounts];
                updatedAccounts[showAccount] = {
                    ...updatedAccounts[showAccount],
                    summaryList: [
                        {
                            asOfDate: null,
                            collector: "",
                            taxYear: "",
                            baseTax: null,
                            baseTaxDue: null,
                            currentMonthDue: null,
                            nextMonthTaxDue: null
                        }
                    ],
                    baseTaxTotal: 0.00,
                    baseTaxDueTotal: 0.00,
                    currentMonthTotal: 0.00,
                    nextMonthTotal: 0.00
                };

                return {
                    ...prev,
                    accounts: updatedAccounts
                };
            });

            setIsTaxSummaryReset(false);
        }
    }, [isTaxSummaryReset]);


    return (
        <>
            <div className="col-lg-12 col-sm-12 border border-highlight-3">
                <div className="border border-surface-5 bg-highlight-5 py-2 text-center text-text-0 flex">
                    <b className="grow">
                        Taxing Jurisdictions - Total Tax Rate: {
                        curAccount?.taxRateTotal != null &&
                        curAccount?.taxRateTotal !== "" &&
                        curAccount?.taxRateTotal > 0.0
                            ? curAccount?.taxRateTotal.toFixed(8)
                            : "N/A"
                    }
                    </b>
                    <i
                        title={"Calculate Next Month Due"}
                        className={
                            !jurisdictionsNextMonthApiResponse.isLoading
                                ? "fa fa-calendar-check ml-3 mt-1 mr-2"
                                : "fas fa-sync fa-spin ml-3 mt-1 mr-2"
                        }
                        onClick={(e) => {
                            if (editable) {
                                e.preventDefault();
                                setReloadJurisdictionNextMonthDue(true);
                            }
                        }}
                    />
                    <i
                        title={"Load Tax Rate"}
                        className={
                            !reloadJurisdictionList
                                ? "fa fa-refresh ml-3 mt-1 mr-2"
                                : "fas fa-sync fa-spin ml-3 mt-1 mr-2"
                        }
                        onClick={(e) => {
                            if (editable) {
                                e.preventDefault();
                                setReloadJurisdictionList(true);
                            }
                        }}
                    />
                </div>
                <div className={'overflow-auto'}>
                    <table className={'w-full'}>
                        {jurisdictionHead(setShowJurisdictionPickerModal, editable)}
                        <tbody>
                        {curAccount?.jurisdictionList?.map((row: any, p: number) => {
                            if (row) {
                                return (
                                    <tr className={"border-b border-surface-5"} key={p}>
                                        <td className="text-center">
                                            <i
                                                onClick={() => {
                                                    if (editable) {
                                                        setJurisdictionIdIndex(p);
                                                        setRemoveJurisdiction(true);
                                                    }

                                                }}
                                                className="fa fa-icon-color text-highlight-5 fa-trash onHover mt-2"
                                                id={p.toString()}
                                                title={"Delete Jurisdiction"}
                                            />
                                        </td>
                                        <td className="text-center  min-w-[110px]" title={row["collectorName"]}>
                                            {row["collectorLink"]?.url ? (
                                                <a
                                                    title={row["collectorName"]}
                                                    href={row["collectorLink"]?.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    role="text"
                                                    className={
                                                        row["placeHolder"] === false
                                                            ? "w-full block bg-text-0 radius-md p-2 text-highlight-0 text-center"
                                                            : "w-full block bg-text-0  border-2 border-surface-8 radius-md p-2 text-highlight-0 text-center"
                                                    }
                                                    data-placeholder="..."
                                                >
                                                    {row["collectorName"]}
                                                  
                                                </a>
                                            ) : hasPermission(["COLLINK-C"]) ? (
                                                <a
                                                    title={row["collectorName"]}
                                                    href={
                                                        row["collectorName"] &&
                                                        row["collectorName"] !== "" &&
                                                        "/collector-links/create"
                                                    }
                                                    onClick={() => {
                                                        if (row["collectorName"]) {
                                                            localStorage.removeItem("collectorObj");
                                                            localStorage.removeItem("collectorLinkType");
                                                        }
                                                    }}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    role="text"
                                                    className={
                                                        row["placeHolder"] === false
                                                            ? "w-full block border-0 !bg-text-0  text-center  text-highlight-0 h-[37px] w-50"
                                                            : "w-full block border-2 border-surface-8 bg-text-0 selector !text-center  text-highlight-0 h-[30px]"
                                                    }
                                                    data-placeholder="..."
                                                >
                                                    {row["collectorName"]}
                                              
                                                </a>
                                            ) : (
                                                <span
                                                    title={row["collectorName"]}
                                                    role="text"
                                                    className={
                                                        row["placeHolder"] === false
                                                            ? "bg text-8 border-0 form-control selector text-center line_break placeholder"
                                                            : " bg text-8 border-2 border-surface-8 text-center "
                                                    }
                                                    data-placeholder="..."
                                                >
                                                        {row["collectorName"]}
                                                    </span>
                                            )}
                                        </td>
                                        <td className="position-relative min-w-[110px]">
                                            <div className="relative bg-text-0">
        <span
            title={row["jurisdictionName"] || ""}
            className="bg text-8 border-0 form-control selector text-center line_break"
            onClick={() => {
                if (!row["jurisdictionId"] && editable) {
                    setJurisdictionIdIndex(p);
                    setType("jurisdiction");
                    setShowAccount(showAccount);
                    setShowJurisdictionModal(true);
                    calculateAsOfDate(row);
                    setAutoCalculate(true);
                }
            }}
        >
            {row["jurisdictionName"] || "Select Juris ..."}
        </span>

                                                {!row["jurisdictionId"] && (
                                                    <span
                                                        className="fa fa-search ml-xl-n4 collector-account-modal absolute right-[10px] top-[12px] text-highlight-0"
                                                        onClick={() => {
                                                            if (editable) {
                                                                setJurisdictionIdIndex(p);
                                                                setType("jurisdiction");
                                                                setShowAccount(showAccount);
                                                                setShowJurisdictionModal(true);
                                                                calculateAsOfDate(row);
                                                                setAutoCalculate(true);
                                                            }
                                                        }}
                                                    />
                                                )}
                                                {row["jurisdictionId"] && row["jurisdictionName"] && (
                                                    <span
                                                        className="fa fa-times ml-xl-n4 center_span_icon absolute right-[10px] top-[12px] text-highlight-0"
                                                        onClick={() => {
                                                            if (editable) {
                                                                setClearJurisRow(true);
                                                                setIsSavedResult(false);
                                                                calculateAsOfDate(row);
                                                                setJurisdictionIdIndex(p);
                                                            }
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </td>
                                        <td className="text-center min-w-[110px]">
                                            {jurisdictionYearFields(
                                                row,
                                                setJurisdictionIdIndex,
                                                p,
                                                curAccount,
                                                setAccounts,
                                                accounts,
                                                setUpdateTotalTaxValue,
                                                setTaxYear,
                                                setIsAddNewSummaryRow,
                                                "bill_year",
                                                row["jurisdictionName"] === "" ||
                                                row["collectorName"] === "" ||
                                                row["jurisdictionName"] === null ||
                                                row["collectorName"] === null,
                                                setIsSavedResult,
                                                editable,
                                                setAutoCalculate
                                            )}
                                        </td>
                                        <td className="text-center  min-w-[190px]">
                                            <NumberFormat
                                                placeholder={
                                                    row["nonCollecting"] === false &&
                                                    row["inActive"] === false
                                                        ? row["tax_rate"] === null ||
                                                        row["tax_rate"] === "" ||
                                                        row["tax_rate"] === undefined
                                                            ? "N/A"
                                                            : "..."
                                                        : row["nonCollecting"] === true
                                                            ? "Non-collecting"
                                                            : "Inactive"
                                                }
                                                className={
                                                    row["placeHolder"] === false
                                                        ? row["tax_rate"] === null ||
                                                        row["tax_rate"] === "" ||
                                                        row["tax_rate"] === undefined
                                                            ? "border-0 form-control text-center place_holder_data"
                                                            : "border-0 form-control text-center"
                                                        : row["tax_rate"] === null ||
                                                        row["tax_rate"] === "" ||
                                                        row["tax_rate"] === undefined
                                                            ? "form-control text-center border-2 border-surface-8"
                                                            : "border-2 border-surface-8 form-control text-center"
                                                }
                                                decimalSeparator="."
                                                fixedDecimalScale
                                                min="0"
                                                isNumericString={
                                                    row["tax_rate"] !== null ||
                                                    row["tax_rate"] !== "" &&
                                                    row["nonCollecting"] === false &&
                                                    row["inActive"] === false
                                                }
                                                value={
                                                    row["nonCollecting"] === false &&
                                                    row["inActive"] === false &&
                                                    (row["tax_rate"] === null ||
                                                    row["tax_rate"] === ""
                                                        ? "N/A"
                                                        : countDecimals(row["tax_rate"]) >= 8
                                                            ? parseFloat(row["tax_rate"]).toFixed(8)
                                                            : row["tax_rate"])
                                                }
                                                thousandSeparator={true}
                                                onChange={(e: any) => {
                                                    setJurisdictionIdIndex(p);
                                                    if (row["placeHolder"] === true) {
                                                        setTaxYear(row["bill_year"]);
                                                        setIsAddNewSummaryRow(true);
                                                    }
                                                    row["placeHolder"] = false;
                                                    row["tax_rate"] = e.target.value;
                                                    setAccounts([...accounts]);
                                                    calculateAsOfDate(row);
                                                    setUpdateTotalTaxValue(true);
                                                    setAutoCalculate(true);
                                                    setIsSavedResult(false);
                                                }}
                                                readOnly={
                                                    row["nonCollecting"] === true ||
                                                    row["jurisdictionName"] === "" ||
                                                    row["jurisdictionName"] === null ||
                                                    row["collectorName"] === "" ||
                                                    row["collectorName"] === null ||
                                                    !editable
                                                }
                                            />
                                        </td>
                                        <td className="text-center  min-w-[110px]">
                                            <JurisdictionRowFormatting
                                                row={row}
                                                setJurisdictionIdIndex={setJurisdictionIdIndex}
                                                p={p}
                                                setAutoCalculate={setAutoCalculate}
                                                name="baseTax"
                                                editable={editable}
                                                setIsSavedResult={setIsSavedResult}
                                                setUpdateTotalTaxValue={setUpdateTotalTaxValue}
                                                setIsAddNewSummaryRow={setIsAddNewSummaryRow}
                                                setTaxYear={setTaxYear}
                                            />

                                        </td>
                                        <td className="text-center  min-w-[110px]">
                                            <JurisdictionRowFormatting
                                                row={row}
                                                setJurisdictionIdIndex={setJurisdictionIdIndex}
                                                p={p}
                                                setAutoCalculate={setAutoCalculate}
                                                name="baseDue"
                                                editable={editable}
                                                setIsSavedResult={setIsSavedResult}
                                                setUpdateTotalTaxValue={setUpdateTotalTaxValue}
                                                setIsAddNewSummaryRow={setIsAddNewSummaryRow}
                                                setTaxYear={setTaxYear}
                                            />

                                        </td>
                                        <td className="text-center min-w-[110px]">
                                            <JurisdictionRowFormatting
                                                row={row}
                                                setJurisdictionIdIndex={setJurisdictionIdIndex}
                                                p={p}
                                                setAutoCalculate={setAutoCalculate}
                                                name="currentMonthDue"
                                                editable={editable}
                                                setIsSavedResult={setIsSavedResult}
                                                setUpdateTotalTaxValue={setUpdateTotalTaxValue}
                                                setIsAddNewSummaryRow={setIsAddNewSummaryRow}
                                                setTaxYear={setTaxYear}
                                            />
                                        </td>
                                        <td className="text-center min-w-[110px]">
                                            <JurisdictionRowFormatting
                                                row={row}
                                                setJurisdictionIdIndex={setJurisdictionIdIndex}
                                                p={p}
                                                setAutoCalculate={setAutoCalculate}
                                                name="nextMonthTaxDue"
                                                editable={editable}
                                                setIsSavedResult={setIsSavedResult}
                                                setUpdateTotalTaxValue={setUpdateTotalTaxValue}
                                                setIsAddNewSummaryRow={setIsAddNewSummaryRow}
                                                setTaxYear={setTaxYear}
                                            />
                                        </td>
                                        <td
                                            className="text-center"
                                            title={
                                                row["asOfDate"] === null || row["asOfDate"] === ""
                                                    ? undefined
                                                    : moment(row["asOfDate"]).format("MM/DD/YYYY").toUpperCase()
                                            }

                                        >
                                            {getShortenedTaxDataSource(
                                                getUserFriendlyTaxDataSource(row["taxDataSource"])
                                            )}
                                        </td>
                                    </tr>
                                );
                            }
                            return null;
                        })}
                        </tbody>
                    </table>
                </div>
                {showJurisdictionModal &&
                    <JurisdictionListModal show={showJurisdictionModal}
                                           setShow={setShowJurisdictionModal}
                                           index={jurisdictionIdIndex}
                                           certificate={certificate}
                                           setCertificate={setCertificate}
                                           setUpdateTotalTaxValue={setUpdateTotalTaxValue}
                                           showAccount={showAccount}
                                           type={type} county={county} orderId={orderId}
                                           setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                           setIsSavedResult={setIsSavedResult}
                    />
                }

                {showJurisdictionPickerModal &&
                    <JurisdictionPickerModal show={showJurisdictionPickerModal} setShow={setShowJurisdictionPickerModal}
                                             certificate={certificate}
                                             setCertificate={setCertificate}
                                             showAccount={showAccount}
                                             county={county} setUpdateTotalTaxValue={setUpdateTotalTaxValue}
                                             setIsSavedResult={setIsSavedResult}
                                             orderId={orderId}
                                             setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                             setRender={setRender}
                                             primaryCollector={primaryCollector}
                    />
                }
            </div>
        </>
    )
}
